import { render, staticRenderFns } from "./SalaryManagement.vue?vue&type=template&id=64b5cbaf&scoped=true&"
import script from "./SalaryManagement.vue?vue&type=script&lang=js&"
export * from "./SalaryManagement.vue?vue&type=script&lang=js&"
import style0 from "./SalaryManagement.vue?vue&type=style&index=0&id=64b5cbaf&lang=scss&scoped=true&"
import style1 from "./SalaryManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5cbaf",
  null
  
)

export default component.exports